import styled from 'styled-components';

export const StyledSearch = styled.div`
  position: absolute;
  right: 6%;

  .ant-input-wrapper {
    right: 10%;
  }

  .ant-input {
    position: absolute;
    left: 5px;
    top: 0;
    height: 29px;
    width: 150px;
  }
  .ant-input-affix-wrapper {
    height: 32px;
    position: relative;
  }

  // for smaller screens
  @media (max-width: 1100px) {
    width: 18vw;
    left: 6%;
    right: unset;

    .ant-input-group-wrapper {
      width: 80% !important;

      .ant-input-wrapper {
        display: flex;
        width: 100%;
        right: unset;

        .ant-input-affix-wrapper {
          width: 100%;
          padding: 4px;

          .ant-input {
            width: 80%;
          }

          .ant-input-suffix {
            width: 10%;
            position: relative;
            left: 90%;
            margin: 0 !important;
          }
        }
      }
    }

    .ant-btn {
      left: 90%;
    }
  }
`;
